import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CAL_DEMO_BOOKING_URL, DISCORD_URL } from '@app/config';
import { DialogService } from '@app/core';
import { TuiButton } from '@taiga-ui/core';
import { PricingContactSalesDialogComponent } from '../../../pricing/components/pricing-contact-sales-dialog/pricing-contact-sales-dialog.component';

@Component({
  selector: 'app-enterprise-cta-section',
  imports: [RouterLink, TuiButton],
  templateUrl: './enterprise-cta-section.component.html',
  styleUrl: './enterprise-cta-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseCtaSectionComponent {
  private readonly dialogService = inject(DialogService);
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;
  protected readonly discordUrl = DISCORD_URL;

  protected async handleContactSales(): Promise<void> {
    await this.dialogService.showComponentDialog(
      PricingContactSalesDialogComponent,
    );
  }
}
